// src/auth/ProtectedDineshRoute.jsx
import { Navigate } from "react-router-dom";

export default function ProtectedDineshRoute({ children }) {
  const isAuthenticated = sessionStorage.getItem("isDineshAuthenticated") === "true";

  if (!isAuthenticated) {
    return <Navigate to="/Dinesh" replace />;
  }

  return children;
}
